import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function TermsPage() {
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Terms of Service"
      lastUpdated={`Last updated: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            By creating an account or using Tellow Up! you agree to these terms.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Service Description</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! is a SaaS platform for repair management. We provide tools for tracking repair status, managing technicians, and coordinating with customers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">User Account</h2>
            <p className="text-nb-text-secondary">
              You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your account credentials. You must be at least 16 years old to use our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Organizations</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! allows users to create or join organizations (shops). Organization admins can invite employees and manage permissions. Users remain responsible for their own actions within the organization.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Release Codes</h2>
            <p className="text-nb-text-secondary">
              A Release Code is a unique identifier that allows customers to track repair status without creating an account. Treat your Release Code as confidential. Tellow Up! is not liable for unauthorized tracking if you share your code.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Acceptable Use</h2>
            <p className="text-nb-text-secondary">
              You agree not to: (a) use the service for illegal purposes; (b) attempt to gain unauthorized access; (c) transmit malicious code; (d) interfere with service operations; (e) scrape or harvest data without permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Intellectual Property</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! and its logo are trademarks. The software and content are protected by intellectual property laws. You retain ownership of data you submit but grant us a license to use it for providing the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Payment and Subscriptions</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! offers subscription plans for organization management. Payments are processed securely through Stripe. You authorize Stripe to charge your payment method for all fees. Subscriptions automatically renew unless cancelled. You can cancel anytime through your account settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Refunds</h2>
            <p className="text-nb-text-secondary">
              All payments are processed through Stripe. Refund requests are handled per Stripe's policies. Contact billing@tellowup.com for payment-related issues.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cancellation</h2>
            <p className="text-nb-text-secondary">
              You may cancel your subscription at any time. Cancellation takes effect at the end of the current billing period. No refunds for partial periods.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Limitation of Liability</h2>
            <p className="text-nb-text-secondary">
              TELLOW UP! IS PROVIDED "AS IS" WITHOUT WARRANTIES. WE ARE NOT LIABLE FOR INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAY US IN THE PAST TWELVE MONTHS.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Modifications</h2>
            <p className="text-nb-text-secondary">
              We may modify these terms at any time. We will notify you via email or by posting a notice on our website. Continued use after modifications constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Governing Law</h2>
            <p className="text-nb-text-secondary">
              For users in Mexico: these terms are governed by Mexican law. For users in the United States: these terms are governed by applicable U.S. federal and state law. For users in France: these terms are governed by French law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contact</h2>
            <p className="text-nb-text-secondary">
              For questions about these terms, contact us at:
            </p>
            <p className="mt-2 text-nb-text-secondary">
              <a href="mailto:legal@tellowup.com" className="text-nb-black font-bold underline">legal@tellowup.com</a>
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
